import { stats } from '@/mocks/sports';

export default function StatsSection() {
  return (
    <section className="w-full py-14 md:py-20 bg-accent-500">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-3">
            数据见证实力
          </h2>
          <p className="text-background-50/75 text-sm md:text-base max-w-xl mx-auto">
            我们以专业服务和海量数据，为数千万体育爱好者提供优质的赛事体验
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 max-w-4xl mx-auto">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-background-50/15 backdrop-blur-sm">
                <i className={`${stat.icon} text-2xl text-background-50`}></i>
              </div>
              <div className="font-heading text-2xl md:text-4xl font-extrabold text-background-50 mb-1">
                {stat.value}
              </div>
              <div className="text-sm text-background-50/70 font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}